import { DropzoneProtected } from '@components'

import { SkeletonBox } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useUploadAttachments } from '@features/attachments/hooks/useUploadAttachments'
import { ExpensesReceiptUploadSources } from '@views/receipts/enums/tracking'
import { useReceiptUploadTracking } from '@views/receipts/hooks/useReceiptUploadTracking'

import { Scope } from '../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../enums/trackingContext'
import { useSegment } from '../../../../../../hooks'
import { useOrgUsesReceiptsOnly } from '../../../../../../hooks/useOrgUsesReceiptsOnly'
import { useGatedUpload } from '../../../../contexts/ReceiptUploadGateContext'
import { useAttachments } from '../../../../hooks/useAttachments'
import { useAttachmentsFilters } from '../../../../hooks/useAttachmentsFilters'
import { ReceiptDropzoneFullScreen } from '../../../ReceiptDropzoneFullScreen'
import * as Styled from './styles'

export const NewReceipt = () => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const [filters] = useAttachmentsFilters()
  const { isLoading } = useAttachments(filters)
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()
  const trackReceiptUpload = useReceiptUploadTracking({
    source: ExpensesReceiptUploadSources.ReceiptEmptyState,
  })

  const { progress, uploadFiles } = useUploadAttachments({
    skipAutoForwardInfoModal: orgUsesReceiptsOnly,
    onSuccess: () => {
      trackReceiptUpload()
      track('File Uploaded (Client)', {
        context: TrackingContext.Uploads,
      })
    },
  })

  const handleDrop = useGatedUpload(uploadFiles)

  return (
    <>
      <Styled.NewReceiptWrapper>
        {isLoading ? (
          <SkeletonBox fullHeight fullWidth />
        ) : (
          <DropzoneProtected
            scopes={Scope.UploadsWrite}
            onDrop={handleDrop}
            trackingContext={TrackingContext.Uploads}
            uploadingText={t('ds.dropzone.uploading_with_counter', {
              current: progress.current,
              total: progress.total,
            })}
          />
        )}
      </Styled.NewReceiptWrapper>
      <ReceiptDropzoneFullScreen
        trackingContext={TrackingContext.Uploads}
        receiptUploadSource={ExpensesReceiptUploadSources.ReceiptEmptyState}
      />
    </>
  )
}
